<!-- ============================================================================= -->
<!-- Ella Custom JS - Customize The Style For Layout -->
<!-- ============================================================================= -->


  $("special-banner").find(".special-banner__lookbook").slick('unslick');

/*  document.addEventListener("DOMContentLoaded", function() {
    var mobileMenuToggle = document.querySelector(".mobileMenu-toggle");
    
    mobileMenuToggle.addEventListener("click", function() {
        var links = document.querySelectorAll("#navigation-mobile .has-megamenu a");
        // Iterar sobre cada enlace y establecer su atributo href a "#"
        links.forEach(function(link) {
            link.setAttribute("href", "#");
        });
    });
  }); */

<!-- ============================================================================= -->
<!-- IMPORTANT DISCLAIMER -->
<!-- Please use only JS to style the layout. -->
<!-- ============================================================================= -->

  // Obtener la referencia al elemento con la clase "container-full" dentro del elemento con el ID "shopify-section-template--17615798534308__special_banner_hfxWVf"
  var targetElement = document.querySelector('#shopify-section-template--17615798534308__special_banner_hfxWVf .container-full');

  // Verificar si el elemento objetivo existe antes de realizar operaciones
  if (targetElement) {
    // Crear el div con la clase "container__span"
    var nuevoDiv = document.createElement('div');
    nuevoDiv.classList.add('container__span');
  
    // Crear el primer span y asignarle el texto correspondiente y la clase "look"
    var spanNuevo = document.createElement('span');
    spanNuevo.textContent = 'Look';
    spanNuevo.classList.add('look');
  
    // Crear el segundo span y asignarle el texto correspondiente y la clase "look"
    var spanLook = document.createElement('span');
    spanLook.textContent = 'Nuevo';
    spanLook.classList.add('nuevo');
  
    // Agregar los span al div
    nuevoDiv.appendChild(spanNuevo);
    nuevoDiv.appendChild(spanLook);
  
    // Agregar el nuevo div al elemento objetivo
    targetElement.appendChild(nuevoDiv);
  } else {
    console.error('Elemento con la clase "container-full" no encontrado en el documento.');
  };

  var links = document.links;
  for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
    if (links[i].hostname !== window.location.hostname) {
      links[i].target = '_blank';
      links[i].rel = 'noreferrer noopener';
    }
  }

  function personalizarElementos() {
  // Modificar el texto del elemento '.header-with-sidebar h1.page-header'
    var elemento = document.querySelector('.header-with-sidebar h1.page-header');
    if (elemento) {
      elemento.textContent = "Blogs";
    };
  };

  // Modificar el texto del primer elemento '.collection-filters__item .sidebarBlock .sidebarBlock-headingWrapper .facets__text'
  var elementoDisponibilidad = document.querySelector('.collection-filters__item .sidebarBlock:nth-child(1) .sidebarBlock-headingWrapper .facets__text');
  if (elementoDisponibilidad) {
    elementoDisponibilidad.textContent = "DISPONIBILIDAD";
  };

  // Modificar el texto del segundo elemento '.collection-filters__item .sidebarBlock .sidebarBlock-headingWrapper .facets__text'
  var elementoPrecio = document.querySelector('.collection-filters__item .sidebarBlock:nth-child(2) .sidebarBlock-headingWrapper .facets__text');
  if (elementoPrecio) {
    elementoPrecio.textContent = "PRECIO";
  };

  // Llamar a la función cuando se cargue la página
  document.addEventListener('DOMContentLoaded', function () {
    personalizarElementos();
  });

(function( root, $, undefined ) {
	"use strict";

	$(function () {

      $(document).ready(function() {
        $(".mobileMenu-toggle").on("click", function() {
          setTimeout(() => {
			$(".list-menu .has-megamenu a.menu_mobile_link_2, #navigation-mobile .has-megamenu a.menu_mobile_link").attr("href", "#");			
            $(".site-nav-mobile.nav .navigation_all_mobile a span").text("VER TODO");
    		}, 500);
        });

        
      });
	});

		
} ( this, jQuery ));
 